<template>
  <div class="wrapper">
    <h1>Activity Home Page</h1>
    <div>
      <router-link to="/activity/covidivide">covidivide</router-link>
      <router-link to="/activity/newdvb">newdvb</router-link>
      <router-link to="/activity/ugdvbbind">ugdvbbind</router-link>
      <router-link to="/activity/bssregister">bssregister</router-link>
      <router-link to="/activity/bssvote">bssvote</router-link>
      <router-link to="/activity/bssvotedetail">bssvotedetail</router-link>
      <router-link to="/activity/bssresult">bssresult</router-link>
      <router-link to="/activity/bsstopic">bsstopic</router-link>
      <router-link to="/activity/bsscomment">bsscomment</router-link>
      <router-link to="/activity/bsshivpost">bsshivpost</router-link>
      <router-link to="/activity/bsshiv">bsshiv</router-link>
      <router-link to="/activity/bssmentor">bssmentor</router-link>
      <router-link to="/activity/bssfinals">bssfinals</router-link>
      <router-link to="/activity/bsspopular2023">bsspopular2023</router-link>
      <router-link to="/activity/europeancup">europeancup</router-link>
      <router-link to="/activity/europeancup2">europeancup2</router-link>
      <router-link to="/activity/varietyvote">varietyvote</router-link>
      <router-link to="/activity/varietyvote2">varietyvote2</router-link>
      <router-link to="/activity/mrrightregistertz">mrrightregistertz</router-link>
      <router-link to="/activity/mrrightvotetz">mrrightvotetz</router-link>
      <router-link to="/activity/leaguematch">leaguematch</router-link>
      <router-link to="/activity/comedy">comedy</router-link>
      <router-link to="/activity/oscar">oscar</router-link>
      <router-link to="/activity/misstz">misstz</router-link>
      <router-link to="/activity/mrrightregisterng">mrrightregisterng</router-link>
      <router-link to="/activity/appvote">appvote</router-link>
      <router-link to="/activity/bssregister2024">bssregister2024</router-link>
      <router-link to="/activity/bssvote2024">bssvote2024</router-link>
      <router-link to="/activity/bssvotedetail2024">bssvotedetail2024</router-link>
      <router-link to="/activity/bssresult2024">bssresult2024</router-link>
      <router-link to="/activity/kssregister">kssregister</router-link>
      <router-link to="/activity/bsspopular2024">bsspopular2024</router-link>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
  created() {},
  mounted() {},
  methods: {}
}
</script>
<style lang="less" scoped>
.wrapper {
  display: flex;
  justify-content: space-around;
  flex-direction: column;
  a {
    display: inline-block;
    width: 33.3%;
    line-height: 20px;
  }
}
</style>
